import React, { useState, useEffect, useRef, useCallback } from "react";
import Dropdown from "../../../Components/CustomDropdown/customdropdown";
import { useToast } from "../../../Utils/toastContext";
import ConfirmContinueButton from "../../../Components/ContinueButton/continue-button";
import ConfirmResetButton from "../../../Components/ContinueButton/reset-button";
import { debounce } from "lodash";
import DocumentPreview from "../../Create-Investment/documentpreview";
import { updateFormData } from "../../../Redux/store/onboardingFormSlice";
import { useDispatch, useSelector } from "react-redux";
import TermsModal from "../../../Components/TermPopup/term-popup";
import AddressAutocomplete from "../../../Components/addressInput/address-input";

const LinkAccount = ({ setCurrentStep, applicationType }) => {
  const formData = useSelector((state) => state.form.formData);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { showToast } = useToast();
  const [showSavedAccount, setShowSavedAccount] = useState(true);
  const [accountHolderName, setAccountHolderName] = useState("");
  const [accountHolderNameUpdate, setAccountHolderNameUpdate] = useState("");
  const [finIdentifier, setFinIdentifier] = useState("");
  const [swiftCode, setSwiftCode] = useState("");
    const [swiftError, setSwiftError] = useState("");
  const [accountNumberUpdate, setAccountNumberUpdate] = useState("");

  const [branchAddress, setBranchAddress] = useState("");
  const [branchAddressUpdate, setBranchAddressUpdate] = useState("");

  const [bsb, setBsb] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [routingNumber, setRoutingNumber] = useState("");
  const [currencyData, setCurrencyData] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [paymentMethodData, setPaymentMethodData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const validateSwift = (value) => {
    const swiftRegex =
      /^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/;
    return swiftRegex.test(value);
  };
  const handleSwiftChange = (e) => {
    const value = e.target.value.toUpperCase(); // optional: auto uppercase
    setSwiftCode(value);

    if (value && !validateSwift(value)) {
      setSwiftError("Invalid SWIFT/BIC format");
    } else {
      setSwiftError("");
    }
  };
  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 2,
    label: "AUD",
  });
  const [preselectedDefaultAccount, setpreselectedDefaultAccount] = useState(
    {}
  );
  const [preselectedPaymentMethod, setPreselectedPaymentMethod] = useState({
    value: 1,
    label: "ACH",
  });
  const [preselectedBranchIdentifier, setpreselectedBranchIdentifier] =
    useState({
      value: 1,
      label: "Australian",
    });
  const [toCurrency, setToCurrency] = useState(2);
  const [defaultAccountId, setDefaultAccountId] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(1);
  const [branchIdentifier, setBranchIdentifier] = useState(1);
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: "AU",
    label: "Australia",
  });
  const [countryCode, setCountryCode] = useState("AU");
  const [achCode, setAchCode] = useState("");
  const [isConfirmDelete, setIsConfirmDelete] = useState(false);
  const [currentBank, setCurrentBank] = useState(null);
  const [currentBankToVerify, setCurrentBankToVerify] = useState(null);
  const [isConfirmVerify, setIsConfirmVerify] = useState(false);
  const [currentBankToDefault, setCurrentBankToDefault] = useState(null);
  const [isConfirmDefault, setIsConfirmDefault] = useState(false);
  const [currentBankToActive, setCurrentBankToActive] = useState(null);
  const [isConfirmActive, setIsConfirmActive] = useState(false);
  const [currentBankToEdit, setCurrentBankToEdit] = useState(null);

  const BranchIdentifierData = [
    {
      value: 1,
      label: "Australian",
    },
    {
      value: 2,
      label: "Non-Australian",
    },
    {
      value: 3,
      label: "U.S",
    },
  ];
  const [bankdata, setBankdata] = useState([
    {
      id: 1,
      bank_name: "Test",
      account_name: "Dummmy",
      account_number: "865213789",
      bsb: "12334",
      swift: "082-356",
      branch_address: "333 George St, Sydney NSW 2000 Australia",
      currency: "AUD",
      branch_identifier: "Australian",
      branch_identifier_id: 1,
      country: "Singapore",
      isVerified: true,
      isDefault: true,
      isActive: true,
      status: "proof_attached",
    },
    {
      id: 2,
      bank_name: "Test",
      account_name: "Dummmy",
      account_number: "865213789",
      bsb: "12334",
      swift: "082-356",
      branch_address: "333 George St, Sydney NSW 2000 Australia",
      currency: "AUD",
      branch_identifier: "Non-Australian",
      branch_identifier_id: 2,
      country: "Singapore",
      fin_identifier: "887222",
      isVerified: false,
      isDefault: false,
      isActive: false,
      status: "proof_attached",
    },
    {
      id: 3,
      bank_name: "Test",
      account_name: "Dummmy",
      account_number: "865213789",
      bsb: "12334",
      swift: "082-356",
      branch_address: "333 George St, Sydney NSW 2000 Australia",
      currency: "AUD",
      branch_identifier: "US",
      branch_identifier_id: 3,
      country: "California",
      fin_identifier: "887222",
      achCode: "887222",
      rountingNumber: "66543",
      paymentMethod: "ACH",
      isVerified: false,
      isDefault: false,
      isActive: false,
      status: "proof_attached",
    },
  ]);
  const [fileBank, setFileBank] = useState(null);
  const [fileBankUpdate, setFileBankUpdate] = useState(null);

  const handleSelectCountryCode = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCode(selectedOption.value);
  };
  const handleSelectToCurrency = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setToCurrency(selectedOption.value);
  };
  const handleSelectDefaultAccount = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setDefaultAccountId(selectedOption.value);
  };
  const handleSelectPaymentMethod = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setPaymentMethod(selectedOption.value);
  };
  const handleSelectBranchIdentifier = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setBranchIdentifier(selectedOption.value);
  };
  const handleDeleteFile = () => {
    setFileBank(null);
  };
  const handleDeleteFileUpdate = () => {
    setIsUpdate(true);
    setFileBankUpdate(null);
  };
  const handleDelete = (bank) => {
    setCurrentBank(bank);
    setIsConfirmDelete(true);
  };
  const handleVerify = (bank) => {
    setCurrentBankToVerify(bank);
    setIsConfirmVerify(true);
  };
  const handleDefault = (bank) => {
    setCurrentBankToDefault(bank);
    setIsConfirmDefault(true);
  };
  const handleActive = (bank) => {
    setCurrentBankToActive(bank);
    setIsConfirmActive(true);
  };
  const handleFileChangeBank = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileBank(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleFileChangeBankUpdate = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const fileType = selectedFile.type;
      const fileSize = selectedFile.size;
      if (
        ["application/pdf", "image/png", "image/jpeg"].includes(fileType) &&
        fileSize <= 10 * 1024 * 1024
      ) {
        setFileBankUpdate(selectedFile);
      } else {
        showToast(
          "File must be PDF, PNG, or JPEG and less than 10MB.",
          "error"
        );
      }
    }
  };
  const handleContinue = () => {
    handlesave();
    if (applicationType == 1) {
      setCurrentStep(5);
    }
    if (applicationType == 2) {
      setCurrentStep(4);
    }
  };
  const handleBack = () => {
    if (applicationType == 1) {
      setCurrentStep(3);
    }
    if (applicationType == 2) {
      setCurrentStep(2);
    }
  };
  const handleReset = () => {
    setCurrentStep(1);
  };
  const addAccount = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        //   const response = await createInvestment();
        //   if (response.status == 200) {
        //     navigate("/investment-hub");
        //   } else {
        //     toastMessage = { message: response.message, type: "error" };
        //   }
        setShowSavedAccount(true);
      } catch (err) {
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      accountHolderName,
      branchAddress,
      toCurrency,
      branchIdentifier,
      bsb,
      countryCode,
      finIdentifier,
      routingNumber,
      paymentMethod,
      achCode,
      accountNumber,
      fileBank,
    ] // Dependencies
  );
  const handleFileClick = (e, rowData) => {
    setcurrentDocument(rowData);
    setIsModalOpen(true);
  };
  const togglePopup = (bank) => {
    setCurrentBankToEdit(bank);
    setIsOpen(!isOpen);
  };
  const handlesave = () => {
    dispatch(updateFormData({ field: "bankdata", value: bankdata }));
  };
  return (
    <div className="flex flex-col min-h-[calc(100vh-100px)] lg:min-w-[80vw] lg:max-w-[80vw]">
      <div className="flex-grow  overflow-visible">
        {loading && (
          <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
            <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
        )}
        <div className="bg-white shadow-md rounded-md p-4">
          <div className="border-b border-colour-custom pb-2">
            <div className="flex items-center space-x-2 mb-2">
              <img src="/cards.svg" alt="User Avatar" className="h-6 w-6" />
              <h1 className="text-xl font-medium">External Account</h1>
            </div>

            <ul className="space-y-2 pl-6 pr-2 text-xs font-medium text-black list-disc">
              <li>
                If your external account information has changed, you will need
                to delete your current external account from your Platform Cash
                Account and enter your new External Account.
              </li>
              <li>
                We only accept external accounts under your personal or
                corporate name.
              </li>
              <li>
                All withdrawal requests from your Caprock Merchant Managed
                Account Platform to your external account are only available to
                users who entered and verified their external account
                information during this stage. You can add more than one
                external account in several currencies by clicking "Add Account"
                after saving the account information.
              </li>
              <li className="text-[#FF5050]">
                If you need to adjust any information from the previous section,
                please click on the “Reset Application” button.
              </li>
            </ul>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            <div className="flex flex-col px-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="">
                <label
                  htmlFor="accountHolderName"
                  className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                >
                  Account Holder Name<span className="text-red-500">*</span>
                </label>
                <input
                  id="accountHolderName"
                  name="accountHolderName"
                  type="text"
                  value={accountHolderName}
                  placeholder="Enter Name"
                  className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                  onChange={(e) => setAccountHolderName(e.target.value)}
                />
              </div>
              <div className="mt-4">
                <label
                  htmlFor="accountHolderName"
                  className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                >
                  Swift Code
                </label>
                <input
                  id="swiftCode"
                  name="swiftCode"
                  type="text"
                  value={swiftCode}
                     onChange={handleSwiftChange}
                                className={`${
                                  swiftError
                                    ? "border-red-300 "
                                    : "border-gray-300 "
                                }
                                  bg-white  border  block w-full p-2 text-black font-medium rounded-md text-md`}
                                placeholder="000000"
                              />
                              {swiftError && (
                                <p className="text-red-500 text-xs mt-1">
                                  {swiftError}
                                </p>
                              )}
              </div>
              <div className="mt-4">
                <label
                  htmlFor="address"
                  className="block text-sm text-labelColour"
                >
                  Branch Address<span className="text-red-500"> *</span>
                </label>
                <AddressAutocomplete
                  onSelect={(addr) => setBranchAddress(addr)}
                />
              </div>
              <div className="mt-4">
                <Dropdown
                  label={
                    <>
                      Currency
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  options={currencyData}
                  search={true}
                  preselectedValue={preselectedcashCurrency}
                  onSelect={handleSelectToCurrency}
                  colorLabel=""
                />
              </div>
            </div>
            <div className="flex flex-col pr-4 pt-4 sm:border-r-0 md:border-r border-gray-300">
              <div className="">
                <Dropdown
                  label={
                    <>
                      Branch Identifier
                      <span className="text-red-500"> *</span>
                    </>
                  }
                  options={BranchIdentifierData}
                  preselectedValue={preselectedBranchIdentifier}
                  onSelect={handleSelectBranchIdentifier}
                />
              </div>
              {branchIdentifier == 1 && (
                <>
                  <div className="mt-4">
                    <label
                      htmlFor="bsb"
                      className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      BSB<span className="text-red-500">*</span>
                    </label>
                    <input
                      id="bsb"
                      name="Bsb"
                      type="text"
                      value={bsb}
                      placeholder="23456789"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setBsb(e.target.value)}
                    />
                  </div>
                </>
              )}
              {branchIdentifier == 2 && (
                <>
                  <div className="mt-4">
                    <Dropdown
                      label={
                        <>
                          Applicant's Country
                          <span className="text-red-500"> *</span>
                        </>
                      }
                      options={countryCodeData}
                      search={true}
                      preselectedValue={preselectedCountryCode}
                      onSelect={handleSelectCountryCode}
                      colorLabel=""
                    />
                  </div>
                  <div className="mt-4">
                    <label
                      htmlFor="finIdentifier"
                      className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Financial Institution Identifier
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="finIdentifier"
                      name="finIdentifier"
                      type="text"
                      value={finIdentifier}
                      placeholder="23456789"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setFinIdentifier(e.target.value)}
                    />
                  </div>
                </>
              )}
              {branchIdentifier == 3 && (
                <>
                  <div className="mt-4">
                    <label
                      htmlFor="finIdentifier"
                      className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                    >
                      Routing Number
                      <span className="text-red-500">*</span>
                    </label>
                    <input
                      id="finIdentifier"
                      name="finIdentifier"
                      type="text"
                      value={routingNumber}
                      placeholder="23456789"
                      className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                      onChange={(e) => setRoutingNumber(e.target.value)}
                    />
                  </div>
                  <div className="mt-4">
                    <Dropdown
                      label={
                        <>
                          Select Payment Method
                          <span className="text-red-500"> *</span>
                        </>
                      }
                      options={paymentMethodData}
                      search={true}
                      preselectedValue={preselectedPaymentMethod}
                      onSelect={handleSelectPaymentMethod}
                      colorLabel=""
                    />
                  </div>
                  {paymentMethod == 1 && (
                    <div className="mt-4">
                      <label
                        htmlFor="finIdentifier"
                        className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                      >
                        ACH Code
                        <span className="text-red-500">*</span>
                      </label>
                      <input
                        id="finIdentifier"
                        name="finIdentifier"
                        type="text"
                        value={achCode}
                        placeholder="23456789"
                        className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                        onChange={(e) => setAchCode(e.target.value)}
                      />
                    </div>
                  )}
                </>
              )}
              <div className="mt-4">
                <label
                  htmlFor="bsb"
                  className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                >
                  Account Number or IBAN<span className="text-red-500">*</span>
                </label>
                <input
                  id="bsb"
                  name="Bsb"
                  type="text"
                  value={accountNumber}
                  placeholder="23456789"
                  className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                  onChange={(e) => setAccountNumber(e.target.value)}
                />
              </div>
            </div>
            <div className="flex flex-col pr-4 pt-4">
              <div className="flex items-center justify-between">
                <label
                  htmlFor="investmentType"
                  className="text-sm text-labelColour  whitespace-normal break-words block"
                >
                  Upload a copy of your External Account Verification document -
                  showing the following details (name, account number, Swift
                  Code, and bank address).
                  <span className="text-red-500">*</span>
                </label>
              </div>
              {/* Drag & Drop Upload Area */}
              <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                <input
                  type="file"
                  id="fileUpload"
                  accept=".pdf,.png,.jpeg"
                  onChange={handleFileChangeBank}
                  className="hidden"
                />
                <img
                  src="/folder-add.svg"
                  alt="Success Icon"
                  className="h-4 w-4"
                />{" "}
                <p className="mt-2 text-gray-500 text-sm">
                  Drag & Drop <br />
                  or <span className="underline">Click to Upload</span>
                </p>
              </label>
              <div className="mt-1">
                <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                  PNG
                </span>
                <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                  JPEG
                </span>
                <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                  PDF
                </span>
                <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                  &#60; 10 MB
                </span>
              </div>
              {fileBank && (
                <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                  <div className="flex-col flex">
                    <span className="text-black">{fileBank.name}</span>
                    <span className="text-[#46DA55] text-xs">
                      Upload Completed
                    </span>
                  </div>
                  <button
                    onClick={handleDeleteFile}
                    className="text-red-500 flex-shrink-0 font-semibold"
                  >
                    <img
                      src="/trash.svg"
                      alt="Success Icon"
                      className="h-4 w-4 flex-shrink-0"
                    />
                  </button>
                </div>
              )}
            </div>
          </div>
          <div className="flex justify-end w-full mt-4">
            <button
              onClick={(e) => {
                e.preventDefault();
                if (!accountHolderName) {
                  showToast("Please Enter Account Holder Name", "error");
                  return;
                }
                if (!branchAddress) {
                  showToast("Please Enter Branch Address", "error");
                  return;
                }
                if (!toCurrency) {
                  showToast("Please Select Currency", "error");
                  return;
                }
                if (!branchIdentifier) {
                  showToast("Please Select Branch Identifier", "error");
                  return;
                }
                if (branchIdentifier == 1 && !bsb) {
                  showToast("Please Enter BSB", "error");
                  return;
                }
                if (branchIdentifier == 2 && !countryCode) {
                  showToast("Please Select Country", "error");
                  return;
                }
                if (branchIdentifier == 2 && !finIdentifier) {
                  showToast(
                    "Please Enter Financial Institution Identifier",
                    "error"
                  );
                  return;
                }
                if (branchIdentifier == 3 && !routingNumber) {
                  showToast("Please Enter Routing Number", "error");
                  return;
                }
                if (branchIdentifier == 3 && !paymentMethod) {
                  showToast("Please Select Payment Method", "error");
                  return;
                }
                if (branchIdentifier == 3 && paymentMethod == 1 && !achCode) {
                  showToast("Please Enter ACH Code", "error");
                  return;
                }
                if (!accountNumber) {
                  showToast("Please Enter Account Number or IBAN", "error");
                  return;
                }
                if (!fileBank) {
                  showToast(
                    "Please upload account verification document",
                    "error"
                  );
                  return;
                }
                setLoading(true);
                addAccount(e);
              }}
              className="w-full md:w-auto bg-black text-white font-medium py-2 px-4 rounded-full text-sm"
            >
              Add Account
            </button>
          </div>
        </div>
        {showSavedAccount && (
          <div className="w-full p-4 mt-4 bg-white rounded-lg shadow-lg">
            {/* Header Section */}
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-100">
              <div className="flex items-center mb-2 md:mb-0">
                <img
                  src="/archive-tick.svg"
                  alt="Company Logo"
                  className="mr-3 w-6 h-6"
                />
                <span className="font-medium lg:text-xl text-sm">
                  Saved External Accounts
                </span>
              </div>
            </div>

            {/* Profile Section */}
            {bankdata.map((bank, index) => (
              <div className="relative flex flex-col lg:flex-row items-start lg:items-center lg:space-x-6 mb-6">
                {/* Toggle Button on Top Right */}
                <div className="absolute top-2 pb-4 right-4 flex items-center space-x-2">
                  {!bank.isDefault && (
                    <button
                      onClick={() => handleDefault(bank)}
                      className="font-semibold border-2 border-[#005A9C] text-[#005A9C] text-[12px] px-3 py-1 rounded-full bg-[#005A9C] bg-opacity-20"
                    >
                      MAKE DEFAULT
                    </button>
                  )}
                  {bank.isDefault && (
                    <button className="font-semibold border-2 border-[#34C046] text-[#34C046] text-[12px] px-3 py-1 rounded-full bg-[#34C046] bg-opacity-20">
                      DEFAULT
                    </button>
                  )}

                  {/* Active Toggle */}
                  <div className="flex items-center space-x-1 text-xs">
                    <span className="text-xs font-medium">
                      {bank.isActive ? "Active" : "InActive"}
                    </span>
                    <label className="inline-flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        className="sr-only peer"
                        checked={bank.isActive}
                        onChange={() => handleActive(bank)}
                      />
                      <div className="w-10 h-5 bg-gray-300 peer-checked:bg-[#75E380] rounded-full relative transition-colors duration-300">
                        <div
                          className={`absolute top-[2px] ${
                            bank.isActive ? "translate-x-[22px]" : "left-[2px]"
                          } bg-white w-4 h-4 rounded-full transition-transform duration-300`}
                        ></div>
                      </div>
                    </label>
                  </div>

                  {/* Delete Button */}
                  <button
                    onClick={() => handleDelete(bank)}
                    className="text-[#FF5050] hover:text-red-600"
                  >
                    <img src="/bag.svg" alt="Delete" className="w-4 h-4" />
                  </button>
                  <button>
                    <img
                      onClick={() => togglePopup(bank)}
                      src="/edit-details.svg"
                      alt="Edit Icon"
                      className=" top-2 right-2 cursor-pointer w-4 h-4"
                    />
                  </button>
                </div>

                <div className="grid border-b grid-cols-1 mt-4 sm:grid-cols-2 md:grid-cols-4 gap-6 w-full pt-6 pr-6">
                  {/* Column 1 */}
                  <div className="flex flex-col md:px-4 md:pt-6">
                    <label
                      htmlFor="refId"
                      className="mb-1 text-xs text-labelColour"
                    >
                      {index + 1}. Account Holder Name
                    </label>
                    <span className="text-sm">{bank.account_name}</span>
                    <div className="mt-4">
                      <label
                        htmlFor="investmentType"
                        className="mb-1 text-xs text-labelColour"
                      >
                        Account Number or IBAN
                      </label>
                      <div className="text-sm">{bank.account_number}</div>
                    </div>
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 mt-4 text-xs"
                    >
                      <span className="text-labelColour">Swift Code</span>
                    </label>
                    <div className="text-sm">{bank.swift}</div>
                    <div className="flex flex-row gap-2 mt-2 mb-2">
                      {bank.isVerified && (
                        <>
                          <button className="bg-white border-[#75E380] border-2 text-[#75E380] text-xs px-2 py-1 rounded-full flex items-center gap-2">
                            <img
                              src="/valid.svg"
                              alt="Camera Icon"
                              className="w-4 h-4"
                            />
                            Verified
                          </button>
                        </>
                      )}
                      {!bank.isVerified && (
                        <>
                          <button className="bg-white border-[#FF5050] border-2 text-[#FF5050] text-xs px-2 py-1 rounded-full flex items-center gap-2">
                            <img
                              src="/danger.svg"
                              alt="Camera Icon"
                              className="w-4 h-4"
                            />
                            Unverified
                          </button>
                          <button
                            onClick={() => handleVerify(bank)}
                            className="bg-black text-white text-xs px-2 py-1 rounded-full flex items-center"
                          >
                            Verify Now
                          </button>
                        </>
                      )}
                    </div>
                  </div>

                  {/* Column 2 */}
                  <div className="flex pb-4 flex-col md:px-4 md:pt-6 md:border-l">
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 text-xs text-labelColour"
                    >
                      Branch Identifier{" "}
                    </label>
                    <span className="text-sm">{bank.branch_identifier}</span>
                    {bank.branch_identifier_id == 1 && (
                      <>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1  mt-4  text-xs text-labelColour"
                        >
                          BSB
                        </label>
                        <span className="text-sm">{bank.bsb}</span>
                      </>
                    )}
                    {bank.branch_identifier_id == 2 && (
                      <>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Country{" "}
                        </label>
                        <span className="text-sm">{bank.country}</span>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Financial Institution Identifier{" "}
                        </label>
                        <span className="text-sm">{bank.fin_identifier}</span>
                      </>
                    )}
                    {bank.branch_identifier_id == 3 && (
                      <>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Routing Number{" "}
                        </label>
                        <span className="text-sm">{bank.rountingNumber}</span>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          Payment Method{" "}
                        </label>
                        <span className="text-sm">{bank.paymentMethod}</span>
                        <label
                          htmlFor="investmentManagerFees"
                          className="mb-1 mt-4 text-xs text-labelColour"
                        >
                          ACH Code{" "}
                        </label>
                        <span className="text-sm">{bank.achCode}</span>
                      </>
                    )}
                  </div>

                  {/* Column 3 */}
                  <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 text-xs"
                    >
                      <span className="text-labelColour">Currency</span>
                    </label>
                    <div className="text-sm">{bank.currency.name}</div>
                    {(bank.status == "proof_attached" ||
                      bank.status == "approved" ||
                      bank.status == "rejected") && (
                      <div className="mb-2 mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-labelColour"
                        >
                          Uploaded Docs
                        </label>
                        <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                          <div className="flex-col flex">
                            <span className="text-black">test.pdf</span>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                    <div className="">
                      <label
                        htmlFor="investmentType"
                        className="mb-1 text-xs text-labelColour"
                      >
                        Address
                      </label>
                      <div className="text-sm">
                        {bank.address_line1 != null ? bank.address_line1 : ""}
                      </div>
                      <div className="text-sm">
                        {bank.address_line2 != null ? bank.address_line2 : ""}
                      </div>
                      <div className="text-sm">
                        {bank.address_line3 != null ? bank.address_line3 : ""}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            {isOpen && currentBankToEdit && (
              <div className="fixed inset-0   flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white h-[90vh] rounded-lg w-[90%] max-w-[700px] p-6 md:max-h-screen md:h-auto  overflow-y-auto">
                  {/* Modal Header */}
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-medium text-center w-full">
                      Edit External Account
                    </h2>
                    <button onClick={togglePopup}>
                      <img
                        src="/add.svg"
                        alt="Close"
                        className="w-8 h-8 md:w-10 md:h-10"
                      />
                    </button>
                  </div>

                  {/* Modal Content */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Left Side */}
                    <div className="space-y-4 md:border-r-2 md:pr-4">
                      <div className="">
                        <label
                          htmlFor="accountHolderName"
                          className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                        >
                          Account Holder Name
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          id="accountHolderName"
                          name="accountHolderName"
                          type="text"
                          disabled={
                            currentBankToEdit.isVerified == true ? true : false
                          }
                          value={accountHolderNameUpdate}
                          placeholder="Enter Name"
                          className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                          onChange={(e) => {
                            setIsUpdate(true);
                            setAccountHolderNameUpdate(e.target.value);
                          }}
                        />
                      </div>

                      <div className="mt-4">
                        <label
                          htmlFor="accountHolderName"
                          className="block dark:text-gray-300 font-normal color-test text-sm mb-1"
                        >
                          Account Number
                        </label>
                        <input
                          id="swiftCode"
                          name="swiftCode"
                          type="text"
                          value={accountNumberUpdate}
                          placeholder="Enter account number"
                          className="rounded-lg h-[2.813rem] border dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium dark:dark:bg-[#101010] dark:border-[#4F4F4F] appearance-none border w-full py-2 px-3  leading-tight focus:outline-none focus:shadow-outline"
                          onChange={(e) => {
                            setAccountNumberUpdate(e.target.value);
                            setIsUpdate(true);
                          }}
                        />
                      </div>
                      <div className="mt-4">
                        <label
                          htmlFor="address"
                          className="block text-sm text-labelColour"
                        >
                          Branch Address<span className="text-red-500"> *</span>
                        </label>
                        <textarea
                          id="address"
                          rows="3"
                          value={branchAddressUpdate}
                          onChange={(e) => {
                            setIsUpdate(true);
                            setBranchAddressUpdate(e.target.value);
                          }}
                          className="w-full mt-2 p-3 border rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                          placeholder="Add address..."
                        />
                      </div>
                    </div>

                    {/* Right Side */}
                    <div className="space-y-4  md:pr-4">
                      <div className="flex flex-col pr-4">
                        <div className="flex items-center justify-between">
                          <label
                            htmlFor="investmentType"
                            className="text-sm text-labelColour  whitespace-normal break-words block"
                          >
                            Upload a copy of your External Account Verification
                            document - showing the following details (name,
                            account number, Swift Code, and bank address).
                            <span className="text-red-500">*</span>
                          </label>
                        </div>
                        {/* Drag & Drop Upload Area */}
                        <label className="border-2 border-dashed rounded-lg p-6 mt-2 block text-center cursor-pointer flex flex-col items-center">
                          <input
                            type="file"
                            id="fileUpload"
                            accept=".pdf,.png,.jpeg"
                            onChange={handleFileChangeBankUpdate}
                            className="hidden"
                          />
                          <img
                            src="/folder-add.svg"
                            alt="Success Icon"
                            className="h-4 w-4"
                          />{" "}
                          <p className="mt-2 text-gray-500 text-sm">
                            Drag & Drop <br />
                            or{" "}
                            <span className="underline">Click to Upload</span>
                          </p>
                        </label>
                        <div className="mt-1">
                          <span className="mt-2 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PNG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            JPEG
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            PDF
                          </span>
                          <span className="mt-1 mr-2 bg-[#8E8E8E] text-white px-2 py-1 rounded-md text-xs">
                            &#60; 10 MB
                          </span>
                        </div>
                        {fileBankUpdate && (
                          <div className="mt-4 bg-white border shadow-md rounded-lg flex items-center justify-between px-3 py-2">
                            <div className="flex-col flex">
                              <span className="text-black">
                                {fileBankUpdate.name}
                              </span>
                              <span className="text-[#46DA55] text-xs">
                                Upload Completed
                              </span>
                            </div>
                            <button
                              onClick={handleDeleteFileUpdate}
                              className="text-red-500 flex-shrink-0 font-semibold"
                            >
                              <img
                                src="/trash.svg"
                                alt="Success Icon"
                                className="h-4 w-4 flex-shrink-0"
                              />
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Modal Footer */}
                  <div className="flex flex-col md:flex-row justify-center md:space-x-4 space-y-2 md:space-y-0 mt-6">
                    <button
                      onClick={togglePopup}
                      className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                    >
                      Cancel
                    </button>
                    <button
                      disabled={!isUpdate}
                      onClick={(e) => {
                        e.preventDefault();
                        setLoading(true);
                      }}
                      className={`px-6 py-2 rounded-lg ${
                        !isUpdate
                          ? "bg-gray-400"
                          : "bg-black text-white hover:bg-gray-800"
                      }`}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </div>
            )}
            {isModalOpen && currentDocument && (
              <DocumentPreview
                fileUrl={currentDocument.proof_image_url}
                fileName={currentDocument.proof_image_name}
                onClose={() => setIsModalOpen(false)}
              />
            )}
            {isConfirmDelete && currentBank && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
                  <button class="absolute top-3 right-3 text-black text-xl font-bold">
                    &times;
                  </button>

                  <div class="flex justify-center items-center mb-4">
                    <div class="flex items-center justify-center">
                      <img
                        src="/delete-warning.svg"
                        alt="Add Template Icon"
                        className="h-10 w-10"
                      />
                    </div>
                  </div>
                  {!currentBank.isDefault && (
                    <>
                      <h2 class="text-lg font-medium mb-2">Are you sure?</h2>
                      <p class="text-sm text-black mb-4">
                        Do you want to delete this external account details?
                      </p>

                      <div class="flex justify-center space-x-4">
                        <button
                          onClick={() => {
                            setIsConfirmDelete(false);
                          }}
                          class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                        >
                          No
                        </button>
                        <button
                          onClick={() => {
                            setIsConfirmDelete(false);
                          }}
                          class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                        >
                          Yes
                        </button>
                      </div>
                    </>
                  )}
                  {currentBank.isDefault && (
                    <>
                      <h2 class="text-lg font-medium mb-2">
                        Are you sure you want to delete the default external
                        account?
                      </h2>
                      <p class="text-sm text-black mb-4">
                        To delete the current default external account, please
                        choose your new default external account from the list
                        below.
                      </p>
                      <div className="m-4">
                        <Dropdown
                          label="Choose Default External Account"
                          options={accountList}
                          search={true}
                          preselectedValue={preselectedDefaultAccount}
                          onSelect={handleSelectDefaultAccount}
                          colorLabel=""
                        />
                      </div>
                      <div class="flex justify-center space-x-4">
                        <button
                          onClick={() => {
                            setIsConfirmDelete(false);
                          }}
                          class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => {
                            setIsConfirmDelete(false);
                          }}
                          class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                        >
                          Confirm
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            )}
            {isConfirmVerify && currentBankToVerify && (
              <TermsModal
                onClose={() => setIsConfirmVerify(false)}
                onConfirm={() => {
                  setIsConfirmVerify(false);
                  // additional logic here
                }}
              />
            )}
            {isConfirmDefault && currentBankToDefault && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
                  <button class="absolute top-3 right-3 text-black text-xl font-bold">
                    &times;
                  </button>

                  <div class="flex justify-center items-center mb-4">
                    <div class="flex items-center justify-center">
                      <img
                        src="/warning-circle.svg"
                        alt="Add Template Icon"
                        className="h-10 w-10"
                      />
                    </div>
                  </div>

                  <h2 class="text-lg font-medium mb-2">Are you sure?</h2>
                  <p class="text-sm text-black mb-4">
                    Do you want to make this external account default?
                  </p>

                  <div class="flex justify-center space-x-4">
                    <button
                      onClick={() => {
                        setIsConfirmDefault(false);
                      }}
                      class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                    >
                      No
                    </button>
                    <button
                      onClick={() => {
                        setIsConfirmDefault(false);
                      }}
                      class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            )}
            {isConfirmActive && currentBankToActive && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div class="bg-white rounded-lg shadow-md w-11/12 max-w-md p-6 text-center">
                  <button class="absolute top-3 right-3 text-black text-xl font-bold">
                    &times;
                  </button>

                  <div class="flex justify-center items-center mb-4">
                    <div class="flex items-center justify-center">
                      <img
                        src="/warning-circle.svg"
                        alt="Add Template Icon"
                        className="h-10 w-10"
                      />
                    </div>
                  </div>

                  {(!currentBankToActive.isDefault ||
                    (currentBankToActive.isDefault &&
                      !currentBankToActive.isActive)) && (
                    <>
                      <h2 class="text-lg font-medium mb-2">Are you sure?</h2>
                      <p class="text-sm text-black mb-4">
                        Do you want to change this external account status?
                      </p>
                      <div class="flex justify-center space-x-4">
                        <button
                          onClick={() => {
                            setIsConfirmActive(false);
                          }}
                          class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                        >
                          No
                        </button>
                        <button
                          onClick={() => {
                            setIsConfirmActive(false);
                          }}
                          class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                        >
                          Yes
                        </button>
                      </div>
                    </>
                  )}
                  {currentBankToActive.isDefault &&
                    currentBankToActive.isActive && (
                      <>
                        <h2 class="text-lg font-medium mb-2">
                          Are you sure you want to deactivate the default
                          external account?
                        </h2>
                        <p class="text-sm text-black mb-4">
                          To deactivate the current default external account,
                          please choose your new default external account from
                          the list below.
                        </p>
                        <div className="m-4">
                          <Dropdown
                            label="Choose Default External Account"
                            options={accountList}
                            search={true}
                            preselectedValue={preselectedDefaultAccount}
                            onSelect={handleSelectDefaultAccount}
                            colorLabel=""
                          />
                        </div>
                        <div class="flex justify-center space-x-4">
                          <button
                            onClick={() => {
                              setIsConfirmActive(false);
                            }}
                            class="px-6 py-2 border rounded-full text-black border-black font-medium hover:bg-gray-100"
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => {
                              setIsConfirmActive(false);
                            }}
                            class="px-6 py-2 bg-black text-white rounded-full font-medium hover:bg-gray-800"
                          >
                            Confirm
                          </button>
                        </div>
                      </>
                    )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <footer className=" mt-4 flex flex-col flex-shrink-0 md:flex-row p-4 bg-[#005A9C]">
        <div className="flex flex-col md:flex-row items-center justify-start w-full space-y-2 md:space-y-0">
          <ConfirmResetButton onConfirm={handleReset} onBack={handleBack} />
        </div>
        <div className="bottom-actions flex flex-col md:flex-row mt-2 md:mt-0 items-center justify-end w-full space-y-2 md:space-y-0 md:space-x-4">
          <div className="w-full md:w-auto flex justify-center md:justify-end">
            <button className="flex w-full md:w-auto items-center justify-center space-x-2 text-white border-white border-2 font-medium py-2 px-4 rounded-full text-sm">
              <span>Save as Draft</span>
            </button>
          </div>
          <ConfirmContinueButton
            onContinue={handleContinue}
            buttonText="Continue"
            confirmTitle="Save Section"
            confirmMessage="Are you sure, you want to continue. This action will ensure, the saved information is un-editable. Therefore please make sure you have provided the correct details."
          />
        </div>
      </footer>
    </div>
  );
};

export default LinkAccount;
